<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        :fill="color"
        id="Capa_1"
        :width="size"
        :height="size"
        viewBox="0 0 477.423 477.424"
        xml:space="preserve"
    >
        <g>
            <g id="Layer_2_29_">
                <g>
                    <path
                        d="M370.616,149.413l20.859-29.471c3.79-5.344,2.521-12.744-2.821-16.539l-31.467-22.281     c-5.351-3.779-12.752-2.516-16.538,2.828l-21.384,30.188c-15.781-7.383-32.728-12.683-50.49-15.495V86.358     c0-7.858,6.434-14.293,14.295-14.293h7.895c7.859,0,14.29-6.437,14.29-14.292V14.301c0-7.866-6.431-14.301-14.29-14.301H186.458     c-7.862,0-14.287,6.435-14.287,14.301v43.472c0,7.855,6.425,14.292,14.287,14.292h7.895c7.862,0,14.296,6.435,14.296,14.293     v12.285c-19.034,3.027-37.14,8.875-53.864,17.119l-21.19-29.905c-3.784-5.345-11.184-6.609-16.538-2.821L85.601,105.31     c-5.347,3.787-6.612,11.195-2.828,16.538l21.365,30.176c-34.588,34.511-56.013,82.21-56.013,134.822     c0,105.089,85.494,190.578,190.588,190.578c105.092,0,190.587-85.489,190.587-190.578     C429.299,232.894,406.759,184.111,370.616,149.413z M238.712,431.688c-79.872,0-144.848-64.979-144.848-144.844     c0-79.867,64.976-144.846,144.848-144.846c79.869,0,144.846,64.979,144.846,144.846     C383.558,366.708,318.582,431.688,238.712,431.688z"
                        :fill="color"
                    />
                    <path
                        d="M358.123,285.889c-0.516-65.411-53.875-118.479-119.41-118.479c-0.32,0-0.63,0.029-0.954,0.029v118.45v120.367     c0.324,0,0.634,0.018,0.954,0.018c65.861,0,119.436-53.568,119.436-119.428C358.147,286.518,358.123,286.202,358.123,285.889z"
                        :fill="color"
                    />
                </g>
            </g>
        </g>
    </svg>
</template>
<style scoped>
</style>
<script>
export default {
    name: 'app-half-time',
    props: {
        color: {
            default: 'black',
            type: String,
        },
        size: {
            default: 24,
            type: Number,
        },
    },
    mounted() {
        console.log('Component %s mounted.', this.$options.name);
    },
    data() {
        return {};
    },
    methods: {},
    computed: {
        width() {
            return this.$props.size + 'px';
        },

        height() {
            return this.$props.size + 'px';
        }
    },
};

</script>
